import React, { FC, useCallback } from 'react';
import { LegacyNote } from '../../../../../../../../interfaces/api/Collaborative';
import useCollaborative from '../../../../../../../../hooks/api/useCollaborative';
import { Order } from '../../../../../../../../interfaces/Table';
import Ticket from '../../../../../../../../interfaces/api/Ticket';
import useTicket from '../../../../../../../../hooks/api/useTicket';
import { useSetRecoilState } from 'recoil';
import { ticketState } from '../../../../../../../../recoil/selectors/tickets';
import NoteTable from './NoteTable';

interface Props {
  hidden?: boolean;
  ticketId: Ticket['id'];
  notesIds: LegacyNote['id'][];
}

const NoteTableContainer: FC<Props> = ({ ticketId, notesIds }) => {
  const setTicket = useSetRecoilState(ticketState(ticketId));
  const { getNotes } = useCollaborative();
  const { removeNote } = useTicket();

  const handleRemoveNote = async (noteId: LegacyNote['id']) => {
    const ticket = await removeNote(ticketId, noteId);
    setTicket(ticket);
  };

  const handleGetNotes = useCallback(
    async (page: number, limit: number, orderBy: keyof LegacyNote, order: Order) => {
      return await getNotes(notesIds || [], page, limit, orderBy, order);
    },
    [notesIds]
  );

  return <NoteTable notesIds={notesIds} onGetNotes={handleGetNotes} onRemoveNote={handleRemoveNote} />;
};

export default React.memo(NoteTableContainer, (prevProps, nextProps) => {
  return prevProps.notesIds === nextProps.notesIds && prevProps.hidden === nextProps.hidden;
});
